import React, { FC } from 'react'

import { RewardsQuery } from '../../../../../../graphql/search'
import { parseRewardsSnapshots } from '../../../../../../lib/rewards/snapshots'
import { SalesAnalyticsCard } from '../SalesAnalyticsCard'
import { SalesLastMonthCard } from '../SalesLastMonthCard'
import * as Styled from './styled'

export interface SalesHistoryCardProps {
  rewardsSnapshots: NonNullable<NonNullable<RewardsQuery['customer']>['rewardsSnapshots']>['nodes']
}

export const SalesHistoryCard: FC<SalesHistoryCardProps> = ({ rewardsSnapshots }) => {
  if (rewardsSnapshots.length === 0) {
    return null
  }
  const [, previousSnapshot] = parseRewardsSnapshots(rewardsSnapshots)
  return (
    <Styled.Card>
      <Styled.Link to="/account/orders">View Orders Details</Styled.Link>
      <Styled.Container>
        <SalesAnalyticsCard rewardsSnapshots={rewardsSnapshots} />
        {previousSnapshot && <SalesLastMonthCard previousSnapshot={previousSnapshot} />}
      </Styled.Container>
    </Styled.Card>
  )
}
